import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetUserEmailAndShouldBeContacted($id: ID!) {
    chat(id: $id) {
      id
      shouldBeContacted
      user {
        id
        email
      }
    }
  }
`);
